/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_OPENSANS_REGULAR: 'OpenSansRegular, sans-serif',
  FONT_UBUNTU_BOLD: 'UbuntuBold, sans-serif',
  FONT_UBUNTU_MEDIUM: 'UbuntuMedium, sans-serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_500: '500',
  //Mobile values
  //H1
  FONT_SIZE_H1: '40px',
  LINE_HEIGHT_H1: '46px',
  LETTER_SPACING_H1: '4px',
  //H2
  FONT_SIZE_H2: '22px',
  LINE_HEIGHT_H2: '32px',
  LETTER_SPACING_H2: '1.3px',
  //H3
  FONT_SIZE_H3: '22px',
  LINE_HEIGHT_H3: '42px',
  LETTER_SPACING_H3: '1.6px',
  //H4
  FONT_SIZE_H4: '14px',
  LINE_HEIGHT_H4: '20px',
  LETTER_SPACING_H4: '1.4px',
  //H5
  FONT_SIZE_H5: '12px',
  LINE_HEIGHT_H5: '13px',
  LETTER_SPACING_H5: '1.2px',
  //P
  FONT_SIZE_P: '16px',
  LINE_HEIGHT_P: '28px',
  LETTER_SPACING_P: '0.3px',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '54px',
    LINE_HEIGHT_H1: '64px',
    LETTER_SPACING_H1: '5.4px',
    //H2
    FONT_SIZE_H2: '32px',
    LINE_HEIGHT_H2: '46px',
    LETTER_SPACING_H2: '1.9px',
    //H3
    FONT_SIZE_H3: '26px',
    LINE_HEIGHT_H3: '38px',
    LETTER_SPACING_H3: '1.6px',
    //H4
    FONT_SIZE_H4: '14px',
    LINE_HEIGHT_H4: '16px',
    LETTER_SPACING_H4: '2.1px',
    //H5
    FONT_SIZE_H5: '12px',
    LINE_HEIGHT_H5: '13px',
    LETTER_SPACING_H5: '0.1px',
    //P
    FONT_SIZE_P: '16px',
    LINE_HEIGHT_P: '32px',
    LETTER_SPACING_P: '0.3px'
  },
  FONT_FACES: ['OpenSansRegular', 'UbuntuMedium', 'UbuntuBold']
};